import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { LoaderComponent } from './common/_components/loader/loader.component';
import { ModalComponent } from './modal/modal.component';
import { TranslatePipe, FormatTextPipe } from './common';
import { TruncatePipe } from './common/_pipes/truncate.pipe';
import { TouchSelectComponent } from './touch-select/touch-select.component';
import { SvgTextComponent } from './common/_components/svg-text/svg-text.component';
import { DebugValueComponent } from './common/_components/debug-value/debug-value.component';
import { QuestionMoodComponent } from './question-mood/question-mood.component';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  declarations: [
    LoaderComponent,
    ModalComponent,
    TranslatePipe,
    FormatTextPipe,
    TruncatePipe,
    TouchSelectComponent,
    SvgTextComponent,
    DebugValueComponent,
    QuestionMoodComponent,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    LoaderComponent,
    ModalComponent,
    TranslatePipe,
    FormatTextPipe,
    TruncatePipe,
    TouchSelectComponent,
    SvgTextComponent,
    DebugValueComponent,
    QuestionMoodComponent,
  ],
})
export class SharedModule {}
